export const WEB_APP_ROOT_ID = 'react-web-app-root'

function getDocument(): Document | null {
    if (typeof document === 'undefined') {
        return null
    }

    return document
}

export function getWebAppRoot(): HTMLElement | null {
    return getDocument()?.getElementById(WEB_APP_ROOT_ID) ?? null
}

export function getWebAppConfigValue(attributeName: string): string | null {
    return getWebAppRoot()?.getAttribute(attributeName) ?? null
}
